import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

export interface CancelBookingData {
  serviceTitle: string;
  deliveryCenterTitle: string;
  bookingDateTime: string;
  subjects?: string[];
}

@Component({
  selector: 'app-cancel-booking-dialog',
  templateUrl: './cancel-booking-dialog.component.html',
})
export class CancelBookingDialogComponent {
  @Input() data: CancelBookingData;

  constructor(protected ref: NbDialogRef<CancelBookingDialogComponent>) {}

  close() { this.ref.close(false); }
  confirm() { this.ref.close(true); }
}
